export const CLASS_BLOCK_NAME = 'bb-loading-indicator';
export const VIEWPORT_MODIFIER = 'viewport';
export const VIEWPORT_LOADING_MODIFIER = 'viewport-loading';
